module.exports = __webpack_public_path__ + "static/video-future-thumbnail-02919ff2fff6799f7f5c64fc226759fc.webp";